<style>
	.friedmap-logo {
		width: 60px;
		position: fixed;
		top: 0;
		left: 0;
		z-index: 1001;
		display: block;
		text-align: center;
		transition: all 300ms;
	}

	nav.mainnav {
		position: fixed;
		left: 0;
		top: 40px;
		height: 100%;
		width: 60px;
		background-color: #444;
		transition: all 200ms;
		transition-delay: 500ms;
		z-index: 1002;
		overflow-x: hidden;
		overflow-y: auto;
	}

	nav.mainnav:hover {
		width: 200px;
		background-color: #444;
	}

	nav.mainnav ul.fried-collapsed, nav.mainnav li {
		list-style-type: none;
		margin: 0;
		padding: 0;
	}

	nav.mainnav ul.fried-collapsed {
		/* position: relative; */
		margin-bottom: 40px;
	}

	nav.mainnav ul.submenu-collapsed, nav.mainnav ul.submenu-expanded {
		margin-bottom: 0px;
	}

	nav.mainnav > ul.fried-collapsed > li {
		min-height: 40px;
		/* position: relative; */
	}

	nav.mainnav ul.fried-collapsed > li:first-of-type {
		display: none;
		height: 40px;
		line-height: 40px;
	}

	nav.mainnav ul.fried-collapsed li a {
		width: 200px;
		color: white;
		display: block;
		overflow: hidden;
		min-height: 40px;
		line-height: 60px;
		text-decoration: none;
	}

	nav.mainnav ul.fried-collapsed li a i {
		display: inline-block;
		text-align: center;
		width: 60px;
	}

	nav.mainnav ul.fried-collapsed li ul.submenu-collapsed {
		display: none;
	}

	nav.mainnav ul.fried-collapsed li:hover ul.submenu-collapsed {
		display: none;
	}

	nav.mainnav ul.fried-collapsed li ul.submenu-expanded {
		display: block;
	}

	nav.mainnav ul.fried-collapsed li a:hover, .router-link-active {
		background-color: #555;
	}

	nav.mainnav ul.submenu-collapsed, nav.mainnav ul.submenu-expanded {
		margin: 0;
		padding: 0;
	}

	nav.mainnav ul.fried-collapsed > li > ul.submenu-expanded a,
	nav.mainnav ul.fried-collapsed > li > ul.submenu-expanded li
	nav.mainnav ul.fried-collapsed > li > ul.submenu-collapsed a,
	nav.mainnav ul.fried-collapsed > li > ul.submenu-collapsed li {
		min-height: 30px;
		line-height: 30px;
	}

	@media screen and (max-width: 1298px) {
		nav.mainnav {
			height: 40px;
			top: 0;
		}

		nav.mainnav ul.fried-collapsed {
			margin-bottom: 0;
		}

		nav.mainnav ul.fried-collapsed li:last-of-type {
			margin-bottom: 40px;
		}

		nav.mainnav ul.fried-collapsed li {
			display: none;
		}

		nav.mainnav ul.fried-collapsed li:first-of-type, nav.mainnav ul.fried-collapsed li:first-of-type a {
			display: block;
			height: 40px;
			line-height: 40px;
		}

		nav.mainnav > ul.fried-collapsed > li {
			height: 40px;
			/* position: relative; */
		}

		nav.mainnav:hover {
			width: 60px;
		}

		nav.fullnav {
			height: 100%;
			width: 200px;
		}

		nav.fullnav ul.fried-collapsed li {
			display: block;
		}

		nav.fullnav:hover {
			height: 100%;
			width: 200px;
		}

		.friedmap-logo {
			left: 40px;
			top: 0;
			right: 200px;
			height: 40px;
			width: auto;
			text-align: center;
		}

		nav.mainnav ul.fried-collapsed {
			/* position: relative; */
			margin-bottom: 0px;
		}

		.menu-icon, .menu-icon a {
			heigh: 40px;
			line-height: 40px;
			min-height: 40px;
		}
	}

	@media screen and (min-width: 1600px) {
		nav.mainnav {
			width: 200px;
		}
	}




	header.topnavi {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		height: 40px;
		background-color: #444;
		z-index: 999;
		transition: all 300ms;
		transition-delay: 250ms;
	}

	header.topnavi:hover {
		background-color: #444;
	}

	header.topnavi ul {
		position: absolute;
		right: 0;
	}

	header.topnavi ul, header.topnavi ul li {
		list-style-type: none;
		margin: 0;
		padding: 0;
	}

	header.topnavi ul li {
		height: 40px;
		line-height: 40px;
		display: inline-block;
		width: 100px;
	}

	header.topnavi ul li a {
		color: white;
		display: block;
		text-decoration: none;
		text-align: center;
	}

	header.topnavi ul li a:hover {
		background-color: #555;
	}

	.menu-icon, .menu-icon a {
		heigh: 40px;
		line-height: 40px;
	}
</style>

<template>
	<div>
		<div class="friedmap-logo">
			<img src="/img/gis_logo_v2.png" alt="dafuq" style="width: 40px; height: 40px;">
		</div>

		<header class="topnavi">
			<ul>
				<li><router-link data-toggle="collapse" data-target=".in" to="/profile/"><i class="fa fa-user fa-fw"></i> <span class="nav-name">Profil</span></router-link></li>
				<li><router-link data-toggle="collapse" data-target=".in" to="/logout/"><i class="fa fa-power-off fa-fw"></i> <span class="nav-name">Abmelden</span></router-link></li>
			</ul>
		</header>

		<nav class="mainnav" id="mainmenu">
			<ul class="fried-collapsed">
				<li class="menu-icon"><a @click="toggleMenu('mainmenu', 'mainnav', 'mainnav fullnav', 'main-content') || this.blur()"><i class="fa fa-bars fa-lg fa-fw"></i> <span class="nav-name">Menü</span></a></li>
				<li v-if="hasDashboard" @click="setClass('mainmenu', 'mainnav')"><router-link data-toggle="collapse" data-target=".in" to="/dashboard/"><i class="fa fa-dashboard fa-lg fa-fw"></i> <span class="nav-name">Dashboard</span></router-link></li>
				<li v-if="hasCustomers" @click="setClass('mainmenu', 'mainnav')"><router-link data-toggle="collapse" data-target=".in" to="/customers/"><i class="fa fa-users fa-lg fa-fw"></i> <span class="nav-name">Kunden</span></router-link></li>
				<li v-if="hasDeceaseds" @click="setClass('mainmenu', 'mainnav')"><router-link data-toggle="collapse" data-target=".in" to="/deceaseds/"><i class="fa fa-user-plus fa-lg fa-fw"></i> <span class="nav-name">Verstorbene</span></router-link></li>
				<li v-if="hasGraves" @click="setClass('mainmenu', 'mainnav')"><router-link data-toggle="collapse" data-target=".in" to="/graves/"><i class="fa fa-battery-quarter fa-lg fa-fw"></i> <span class="nav-name">Gräber</span></router-link></li>
				<li v-if="hasAreas" @click="setClass('mainmenu', 'mainnav')"><router-link data-toggle="collapse" data-target=".in" to="/areas/"><i class="fa fa-object-group fa-lg fa-fw"></i> <span class="nav-name">Flächen</span></router-link></li>

				<li v-if="hasUndertakers" @click="setClass('mainmenu', 'mainnav')"><router-link data-toggle="collapse" data-target=".in" to="/undertakers/"><i class="fa fa-male fa-lg fa-fw"></i> <span class="nav-name">Bestatter</span></router-link></li>
				<li v-if="hasCrematories" @click="setClass('mainmenu', 'mainnav')"><router-link data-toggle="collapse" data-target=".in" to="/crematories/"><i class="fa fa-fire fa-lg fa-fw"></i> <span class="nav-name">Krematorien</span></router-link></li>

				<li v-if="hasSettings"><a @click="toggleMenu('settings-menu')"><i class="fa fa-cog fa-lg fa-fw"></i> <span class="nav-name">Einstellungen</span></a>
					<ul id="settings-menu" class="submenu-collapsed">
						<li v-if="hasAreaCategories" @click="setClass('mainmenu', 'mainnav')"><router-link to="/area_types/"><i></i> <span class="nav-name">Flächenarten</span></router-link></li>
						<li v-if="hasGraveCategories" @click="setClass('mainmenu', 'mainnav')"><router-link to="/grave_types/"><i></i> <span class="nav-name">Grabarten</span></router-link></li>
						<li v-if="hasBurialTypes" @click="setClass('mainmenu', 'mainnav')"><router-link to="/burial_types/"><i></i> <span class="nav-name">Bestattungsarten</span></router-link></li>
						<li v-if="hasDenominations" @click="setClass('mainmenu', 'mainnav')"><router-link to="/denominations/"><i></i> <span class="nav-name">Konfessionen</span></router-link></li>
						<li v-if="hasUsers" @click="setClass('mainmenu', 'mainnav')"><router-link to="/users/"><i></i> <span class="nav-name">Benutzer</span></router-link></li>
						<li v-if="hasRoles" @click="setClass('mainmenu', 'mainnav')"><router-link to="/roles/"><i></i> <span class="nav-name">Rollen</span></router-link></li>
						<li v-if="hasGraveyards" @click="setClass('mainmenu', 'mainnav')"><router-link to="/graveyards/"><i></i> <span class="nav-name">Friedhöfe</span></router-link></li>
					</ul>
				</li>
			</ul>
		</nav>
	</div>
</template>

<script>
	import store from 'root/store.js'
	import { getRoutes } from 'functions/auth_check'

	export default {
		mounted () {
			this.routes = getRoutes()
		},

		data () {
			return { routes: [] }
		},

		methods: {
			checkPage (aPage) {
				const route = this.routes.find(page => page.path === aPage)
				return route !== undefined && route.level > 1
			},

			toggleMenu (aID, from, to, focus) {
				let element = document.getElementById(aID)

				if (typeof from === "undefined") {
					from = "submenu-collapsed"
				}

				if (typeof to === "undefined") {
					to = "submenu-expanded"
				}

				if (element.className === from) {
					element.className = to
				} else {
					element.className = from
					if (typeof focus !== "undefined") {
						document.getElementById(focus).focus()
					}
				}
			},

			setClass (aID, aClass) {
				let element = document.getElementById(aID)
				element.className = aClass
			}
		},

 		computed: {
			hasDashboard () {
				return this.checkPage('dashboard')
			},

			hasDeceaseds () {
				return this.checkPage('deceaseds')
			},

			hasCustomers () {
				return this.checkPage('customers')
			},

			hasGraves () {
				return this.checkPage('graves')
			},

			hasAreas () {
				return this.checkPage('areas')
			},

			hasAreaCategories () {
				return this.checkPage('area_categories')
			},

			hasGraveCategories () {
				return this.checkPage('grave_categories')
			},

			hasBurialTypes () {
				return this.checkPage('burial_types')
			},

			hasDenominations () {
				return this.checkPage('denominations')
			},

			hasSettings () {
				return this.hasAreaCategories ||
						this.hasGraveCategories ||
						this.hasBurialTypes ||
						this.hasDenominations ||
						this.hasUsers ||
						this.hasRoles ||
						this.hasGraveyards
			},

			hasUndertakers () {
				return this.checkPage('undertakers')
			},

			hasCrematories () {
				return this.checkPage('crematories')
			},

			hasUsers () {
				return this.checkPage('users')
			},

			hasRoles () {
				return this.checkPage('roles')
			},

			hasGraveyards () {
				return this.checkPage('graveyards')
			},

		}
	}
</script>



// WEBPACK FOOTER //
// NaviView.vue?5bd6446c